import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  colors,
  Container,
  Hidden,
  Paper,
  Typography,
} from "@material-ui/core";
import fontConfig from "../../constants/fonts";
import FancyButton from "../Common/Buttons/FancyButton";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "flex-end",
    height: "40vh",
    // padding: theme.spacing(2),
    // backgroundColor: "red",
    [theme.breakpoints.down("md")]: {
      padding: 0,
      width: "100vw",
      height: "auto",
    },
  },
  Container: {
    // height: "50vh",
    backgroundColor: "transparent",
    // display: "flex",
    // alignItems: "flex-end",
    // position: "relative",

    zIndex: 10,
    [theme.breakpoints.down("md")]: {
      height: "18vh",
      // backgroundColor: "red",
    },
  },

  img: {
    // height: "40vh",
    width: "100%",
    // borderRadius: 20,
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      height: "18vh",
      // width: "30vw",
    },
  },
}));

const CarouselItem = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
        <Paper className={classes.Container} elevation={0}>
          <img src={data.imageSrc} className={classes.img} />
        </Paper>
      </Container>
    </div>
  );
};
export default CarouselItem;
